var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"rounded":"","x-large":"","color":"success","to":{name:'rent'}}},[_c('v-icon',[_vm._v(_vm._s(_vm.mdi.bike))]),_c('span',{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.buttonText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }